import { createFileRoute } from "@tanstack/react-router";
import { processScheduleFromNowQueryOptions } from "@/features/schedules/api/processSchedule";
import { selectScheduleById } from "@/features/schedules/api/selectSchedulesById";
import TimingPreviewCard from "@/features/schedules/components/TimingPreviewCard";

const ScheduleView = () => {
    const { processedSchedule } = Route.useLoaderData();

    return (
        <section className="mx-auto py-8 container">
            <TimingPreviewCard processedSchedule={processedSchedule || []} />
        </section>
    );
};

export const Route = createFileRoute("/_app/schedules/$scheduleId")({
    component: ScheduleView,
    loader: async ({ context, params }) => {
        const schedule = await selectScheduleById(params.scheduleId);
        const processedSchedule = await context.queryClient.ensureQueryData(
            processScheduleFromNowQueryOptions(schedule)
        );
        return { processedSchedule };
    },
});
